<script setup lang="ts">
defineProps<{
  modelValue: string
  resolvedLabel: string
}>()

defineEmits<{
  'update:modelValue': [value: string]
}>()

const inputId = 'deadline-picker-input'
const labelId = `${inputId}-resolved`
</script>

<template>
  <div class="deadline-picker">
    <label class="deadline-picker__label" :for="inputId">Færdig kl.</label>
    <div class="deadline-picker__field">
      <input
        :id="inputId"
        class="deadline-picker__input"
        type="time"
        :value="modelValue"
        :aria-describedby="labelId"
        @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      />
    </div>
    <p :id="labelId" class="deadline-picker__resolved" aria-live="polite">
      {{ resolvedLabel }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.deadline-picker {
  display: flex;
  flex-direction: column;
  gap: space(2);

  &__label {
    font-weight: $font-weight-semibold;
    color: color('ink');
    font-size: $font-size-sm;
  }

  &__field {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    padding: space(1) space(3);
    background: color('white');
    border: 1px solid color('background-medium');
    border-radius: $radius-md;
    transition: border-color $duration-base $easing-standard;

    &:focus-within {
      border-color: color('accent');
      box-shadow: 0 0 0 3px rgb(0, 176, 62, 0.15);
    }
  }

  &__input {
    padding: space(1) 0;
    background: transparent;
    border: none;
    outline: none;
    font-family: inherit;
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
    color: color('primary');
    color-scheme: light;
    min-width: 6rem;
  }

  &__resolved {
    margin: 0;
    font-size: $font-size-xs;
    color: color('ink-light');
    font-style: italic;
  }
}
</style>
